<template>
  <div class="unit-energy">
    <title-one class="m-top" :title="title || ''" :ps-txt="psTitle || ''" />
    <div class="rank-four left">
      <wh-echarts :id="'leftFour'" :option="option" />
    </div>
  </div>
</template>

<script>
import TitleOne from '@/components/TitleOne/TitleOne'
import WhEcharts from '@/components/WhEcharts/WhEcharts'
export default {
  name: 'UnitEnergy',
  components: { WhEcharts, TitleOne },
  props: {
    title: {
      type: String,
      default: () => ''
    },
    psTitle: {
      type: String,
      default: () => ''
    },
    option: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style scoped>
  .rank-four{
    width: 100%;
    height: 294px;
    background: url("../../images/left-4.png") top left no-repeat;
    background-size: 100% 100%;
  }
  .left{
    position: relative;
    top: -6px;
  }
</style>
